// extracted by mini-css-extract-plugin
module.exports = {"dialogNewsletterTip":"DialogNewsletterTip_dialogNewsletterTip_1pZbD"};